import gql from 'graphql-tag';
import { CreateDocumentFragments } from './create-document.fragments';

export class CreateDocumentMutations {
  static updateDocument = gql`
    mutation updateDocument(
      $documentId: String!
      $settings: UpdateDocumentSettings
      $patch: UpdateDocumentPatch!
    ) {
      updateDocumentV2(documentId: $documentId, settings: $settings, patch: $patch)
    }
  `;

  static implementResource = gql`
    mutation implementResourceInDocument($payload: ImplementResourceInDocumentPayload!) {
      implementResourceInDocument(payload: $payload) {
        id
        resourceId
        contentId
        documentId
        inTemplate
      }
    }
  `;

  static implementTemplate = gql`
    mutation implementTemplateInDocument(
      $documentId: String!
      $templateId: String!
      $pageOffset: Int!
    ) {
      implementTemplateInDocument(
        documentId: $documentId
        templateId: $templateId
        pageOffset: $pageOffset
      ) {
        ...templateDocumentFragment
      }
    }
    ${CreateDocumentFragments.templateDocument}
  `;
}
